import ReactD3MultiSeriesChart from "../../../../AxiomComponents/AxiomUI/ReactD3MultiSeriesChart/ReactD3MultiSeriesChart";

function targetAchievementChartComponent(
  componentName,
  availableHeight,
  availableWidth,
  data,
  appName,
  appID,
  field,
  value,
  pointInfo
) {
  data = data.sort((a, b) => {
    return new Date(a.date).getTime() - new Date(b.date).getTime();
  });
  // console.log(pointInfo);
  const totalPoints = data.length;
  const negativePoints = data.length;
  const total_days_in_month = +pointInfo.data.total_days_in_month;
  const remaining_days_in_month = total_days_in_month - totalPoints;
  const title = [
    // { text: `${negativePoints} out of ${totalPoints}`, class: "highlight" },
    // { text: `months are having negative growth for ${field}` },
    // { text: value, class: "highlight" },
  ];
  const chartData = {
    id: AxiomAPIs.generateUUID(16, "aA"),
    config: {
      width: availableWidth,
      height: availableHeight,
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      data: data,
      margins: {
        top: 10,
        right: 50,
        bottom: 30,
        left: 60,
      },
      globalTooltip: true,
      xAxis: [
        {
          categories: new Array(total_days_in_month).fill(null).map((d, i) => i + 1),
          orient: "bottom",
          crosshair: false,
          lineColor: "#808080",
          lineWidth: 0.5,
          tickColor: "#808080",
          tickLineRequired: true,
          tickWidth: 0.5,
          labels: {
            style: {
              fontSize: "14px",
            },
            format: "",
            prefix: "",
            postfix: "",
          },
          gridLineWidth: 1,
        },
      ],
      yAxis: [
        {
          orient: "left",
          title: {
            text: "",
            style: {},
          },
          zeroBase: false,
          crosshair: false,
          lineColor: "#808080",
          lineWidth: 0.01,
          tickColor: "#808080",
          tickLineRequired: false,
          ticks: 5,
          tickWidth: 0.5,
          stackLabels: {},
          labels: {
            style: {
              fontSize: "14px",
            },
            format: "0.[0]a",
            prefix: "",
            postfix: "",
          },
        },
      ],
      series: [
        {
          type: "line",
          yAxis: 0,
          name: "MTD",
          data: [...data.map((d) => +d.value), ...new Array(remaining_days_in_month).fill(null)],
          dataLabels: {
            enabled: false,
            style: {
              fontSize: "12px",
            },
          },
          lineStyle: {
            strokeWidth: "1.2",
            fillColor: "#4aa4b8",
          },
        },
        {
          type: "line",
          yAxis: 0,
          name: "Prorated MTD Target",
          data: new Array(total_days_in_month)
            .fill(null)
            .map((d, i) => (+pointInfo.data.Target / total_days_in_month) * (i + 1)),
          dataLabels: {
            enabled: false,
            style: {
              fontSize: "12px",
            },
          },
          lineStyle: {
            strokeDashArray: "5 3",
            strokeWidth: "1.2",
            fillColor: "#ccc",
          },
        },
        {
          type: "line",
          yAxis: 0,
          name: "Lowest Achievable",
          data: [
            ...new Array(total_days_in_month - remaining_days_in_month - 1).fill(null),
            +pointInfo.data.MTD,
            ...new Array(remaining_days_in_month)
              .fill(null)
              .map(
                (d, i) =>
                  +pointInfo.data.MTD +
                  ((+pointInfo.data.lower_achievement - +pointInfo.data.MTD) /
                    remaining_days_in_month) *
                    (i + 1)
              ),
          ],
          dataLabels: {
            enabled: false,
            style: {
              fontSize: "12px",
            },
          },
          lineStyle: {
            strokeDashArray: "5 3",
            strokeWidth: "1.2",
            fillColor: "#3AA933",
          },
        },
        {
          type: "line",
          yAxis: 0,
          name: "Average Achievable",
          data: [
            ...new Array(total_days_in_month - remaining_days_in_month - 1).fill(null),
            +pointInfo.data.MTD,
            ...new Array(remaining_days_in_month)
              .fill(null)
              .map(
                (d, i) =>
                  +pointInfo.data.MTD +
                  ((+pointInfo.data.average_achievement - +pointInfo.data.MTD) /
                    remaining_days_in_month) *
                    (i + 1)
              ),
          ],
          dataLabels: {
            enabled: false,
            style: {
              fontSize: "12px",
            },
          },
          lineStyle: {
            strokeDashArray: "5 3",
            strokeWidth: "1.2",
            fillColor: "#FFED02",
          },
        },
        {
          type: "line",
          yAxis: 0,
          name: "Highest Achievable",
          data: [
            ...new Array(total_days_in_month - remaining_days_in_month - 1).fill(null),
            +pointInfo.data.MTD,
            ...new Array(remaining_days_in_month)
              .fill(null)
              .map(
                (d, i) =>
                  +pointInfo.data.MTD +
                  ((+pointInfo.data.upper_achievement - +pointInfo.data.MTD) /
                    remaining_days_in_month) *
                    (i + 1)
              ),
          ],
          dataLabels: {
            enabled: false,
            style: {
              fontSize: "12px",
            },
          },
          lineStyle: {
            strokeDashArray: "5 3",
            strokeWidth: "1.2",
            fillColor: "#E1010C",
          },
        },
      ],
      legend: [],
    },
  };
  const component = (
    <ReactD3MultiSeriesChart {...chartData} appName={appName} appID={appID} componentID="0" />
  );
  // const component = <div />
  return { title, component };
}

module.exports = targetAchievementChartComponent;
